import { createTheme, PaletteMode, ThemeOptions } from "@mui/material";
import { Typography } from "./typography";
import { TypographyOptions } from "@mui/material/styles/createTypography";

export default function Theme() {
  const themeTypography: TypographyOptions = Typography(`'Inter', 'Roboto', sans-serif`);

  const themeBreakpoints = {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  };

  const themePalette = {
    mode: "light" as PaletteMode,
    primary: {
      main: "#6366f1", // Indigo - nowoczesny, elegancki
      light: "#818cf8",
      dark: "#4f46e5",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#8b5cf6", // Violet - elegancki akcent
      light: "#a78bfa",
      dark: "#7c3aed",
      contrastText: "#ffffff",
    },
    error: {
      main: "#ef4444",
      light: "#f87171",
      dark: "#dc2626",
    },
    warning: {
      main: "#f59e0b",
      light: "#fbbf24",
      dark: "#d97706",
    },
    info: {
      main: "#06b6d4",
      light: "#22d3ee",
      dark: "#0891b2",
    },
    success: {
      main: "#10b981",
      light: "#34d399",
      dark: "#059669",
    },
    background: {
      default: "#f9f5ef", // Zgodnie z wytycznymi - ciepły beż
      paper: "#ffffff",
    },
    text: {
      primary: "#2f2f2f", // Zgodnie z wytycznymi
      secondary: "#6c6c6c", // Zgodnie z wytycznymi
    },
    grey: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
    },
  };

  const ThemeOptions: ThemeOptions = {
    breakpoints: themeBreakpoints,
    palette: themePalette,
    typography: themeTypography,
    shape: {
      borderRadius: 10, // Zgodnie z wytycznymi
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: "#ffffff",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
            borderBottom: "1px solid #eee",
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            textTransform: "none",
            fontWeight: 500,
            fontSize: "0.875rem",
            minHeight: 48,
            minWidth: "auto",
            padding: "8px 16px",
            "&.Mui-selected": {
              color: "#6366f1",
              fontWeight: 600,
            },
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          indicator: {
            backgroundColor: "#6366f1",
            height: 2,
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
            borderRadius: 10,
            border: "1px solid #eee",
            backgroundColor: "#ffffff",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            fontWeight: 500,
            borderRadius: 6,
            padding: "12px 20px",
            fontSize: "14px",
          },
          contained: {
            backgroundColor: "#6366f1",
            "&:hover": {
              backgroundColor: "#4f46e5",
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-root": {
              borderRadius: 6,
              fontSize: "14px",
              "& fieldset": {
                borderColor: "#ddd",
              },
              "&:hover fieldset": {
                borderColor: "#6366f1",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#6366f1",
              },
            },
          },
        },
      },
    },
  };

  return createTheme(ThemeOptions);
}
